export { default } from "./FeaturedStoresWidget";
export { default as FeaturedStoresWidget, useFeaturedStoresWillRender } from "./FeaturedStoresWidget";



// WEBPACK FOOTER //
// ./src/components/FeaturedStoresWidget/index.ts